const stringsDE = {
  'general.loggingIn': 'Einloggen...',
  'general.invalidPassword': 'Passwort ungültig, versuchen Sie es erneut',
  'general.goToLogin': 'Zur Anmeldung',
  'general.loggedOutText': 'Sie haben sich abgemeldet',
  'general.changePassword': 'Passwort ändern',
  'general.modified': 'Geändert',
  'general.mobile': 'Mobiltelefon',
  'general.desktop': 'Startseite',
  'general.backTo': 'Zurück zu',
  'general.synced': 'Synchronisiert',
  'general.assigned': 'zugewiesen',
  'general.notAssigned': 'nicht zugewiesen',
  'menuLabel.notesAndDocuments': 'Anmerkungen und Dokumente',
  'plants.filterByTag': 'Nach Stichwort filtern',
  'plants.recentlyModified': 'Sortieren nach Kürzlich geändert',
  'plants.plantName': 'Sortieren nach Anlagenname',
  'newPlantDialog.insertGroup':
    '+ fügen Sie eine neue Gruppe hinzu und drücken Sie Eingabe',
  'plantDetail.addDevice': 'Gerät hinzufügen',
  'plantDetail.addObjects': 'Objekte hinzufügen',
  'plants.noPlantsHint':
    'Klicken Sie auf "Neue Anlage", um eine neue Anlage zu erstellen',
  'plantDetail.newUpdates': 'Neue Updates',
  'plantDetail.willRefreshToReflectChanges':
    'Dieses Element wurde überarbeitet. Die Seite wird aktualisiert, um die Änderungen anzuzeigen.',
  'plantDetail.addGroup': 'Gruppe hinzufügen',
  'plantDetail.addScene': 'Szenario hinzufügen',
  'plantC300EOSSettings.GeneralSettings': 'Allgemeine Einstellungen',
  'plantC300EOSSettings.DoorEntryParametrs': 'SPRECHANLAGEN-PARAMETER',
  'plantC300EOSSettings.descPage':
    'Nicht alle Parameter können in diesem Abschnitt bearbeitet werden: Sie müssen dies vor Ort mit der verbundenen App tun',
  'general.favourites': 'Favoriten',
  'general.select': 'Auswählen',
  'general.operationError': 'Bedienungsfehler',
  'plantDetail.lastScan': 'Letzter Scan: {date} um {time}',
  'general.assignIcon': 'Symbol zuweisen',
  'general.assignedIcon': 'Symbol zugewiesen',
  'newPlantDialog.modified': 'Anlage wurde geändert',
  'plantDetail.deletePlantConfirm':
    'Sind Sie sicher, dass Sie {plantName} löschen möchten? Alle Daten gehen dann verloren. Zum Löschen geben Sie den Code {code} ein und bestätigen Sie',
  'plantDetail.objectsCreated': 'Objekte erfolgreich erstellt',
  'plantDetail.selectDevice':
    'Wählen Sie ein Gerät aus, um seine Module anzuzeigen',
  'plantDetail.typeNameGroup': 'Gruppentyp und -name',
  'plantDetail.disableScene': 'Szenario deaktivieren',
  'plantDetail.disableSceneConfirm':
    'Sind Sie sicher, dass Sie das Szenario "{sceneName}" deaktivieren möchten?',
  'plantC300EOSSettings.SetAsPrimaryEntryUnitDESC':
    'Die Haupt-Innensprechstelle ist die einzige, die den Anruf von der App weiterleitet und den Anrufbeantworter verwaltet',
  'plantC300EOSSettings.ProfessionalStudioDESC':
    'Wenn vom Benutzer aktiviert, öffnet die Arztschaltung das Türschloss, wenn jemand anläutet',
  'scenes.trigger': 'Trigger',
  'uniqueNaming.validationError': 'Name ungültig',
  'uniqueNaming.unavailableName': 'Name nicht verfügbar',
  'uniqueNaming.roomInlineNamingError': 'Name konnte nicht aktualisiert werden',
  'uniqueNaming.roomInlineNamingSuccess': 'Raumname aktualisiert',
  'uniqueNaming.nameResetDisclaimer':
    'Der Name wird auf den ursprünglichen Namen zurückgesetzt',
  'uniqueNaming.validationErrorWithSuggestion':
    'Name ist ungültig, Sie können es versuchen mit: "{suggestedName}"',
  'plantsList.duplicateDialog.inputLabel':
    'Sie können die Namen der Anlagen hier anpassen',
  'plantDialogDuplicate.howManyCopies': 'Wie viele Kopien',
  'plantDialogDuplicate.success': 'Anlage dupliziert',
  'general.actuatorAdded': 'Aktor hinzugefügt',
  'general.commandAdded': 'Befehl hinzugefügt',
  isEditingPlant: 'bearbeitet die Konfiguration',
  eliotParseException:
    'Problem beim Lesen der Anlagenkonfiguration aus der Cloud.', // assignObject: {
  //   selectFromLastScan: 'Select from last scan',
  //   selectFromCatalogue: 'Select from catalogue',
  // },
  // assignThermo: {
  //   selectOnlyOneDescription:
  //     'TEMP STRING You should select one and only one device.',
  //   thermostatAdded: 'Thermostat added',
  //   heatingActuatorAdded: 'Heating actuator added',
  //   coolingActuatorAdded: 'Cooling actuator added',
  //   sharedActuatorAdded: 'Shared actuator added',
  //   heatingPumpAdded: 'Heating pump added',
  //   coolingPumpAdded: 'Cooling pump added',
  //   sharedPumpAdded: 'Shared pump added',
  //   probeAdded: 'Probe added',
  // },
};
export default stringsDE;
